<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
      dense
    >
      <v-toolbar-title>Edit Mapping</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items class="hidden-sm-and-down">

      </v-toolbar-items>
    </v-toolbar>
    <v-card-title>Map Datasource into an Email template and provide fallback values</v-card-title>
    <v-card-text>
      <v-container>
        <v-row class="pb-4"  >
          <v-col cols="3" class="text-h6 text-sm-center mr-4">
            {{ lhsTitle }}
          </v-col>
          <v-col cols="3" class="text-h6 text-sm-center mr-4">
            {{ rhsTitle }}
          </v-col>
          <v-col cols="3" class="text-h6 text-sm-center">
            {{ defaultValueTitle }}
          </v-col>
        </v-row>

        <v-row  v-for="(lhsModel,idx) in lhsData" :key="idx">
          <v-col cols="3" class="subheading text-sm-center mr-4 pt-3" >
            {{ lhsModel }}
          </v-col>
          <v-col class="mr-4" cols="3" >
            <v-autocomplete
              v-model="rhsData[idx]"
              :items="rhsFields"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="defaultValueData[idx]"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
   </v-card-text>
   <v-card-actions class="justify-center">
    <v-btn v-on:click.prevent="closeMapper">Cancel</v-btn>
    <v-btn color="primary" v-on:click.prevent="saveEventMapping">Update</v-btn>
   </v-card-actions>
  </v-card>
</template>

<script>
const R = require('ramda')

export default {
  name: 'field-map-editor',
  props: {
    value: {
      type: Array,
      required: true
    },
    lhsTitle: {
      type: String,
      required: true
    },
    rhsTitle: {
      type: String,
      required: true
    },
    defaultValueTitle: {
      type: String,
      require: false,
      default: 'Fallback Value'
    },
    lhsValues: {
      type: Array,
      required: true,
      default: () => []
    },
    rhsValues: {
      type: Array,
      required: true,
      default: () => []
    },
    errorMessages: {
      type: Array,
      required: false
    },
    mappingPresets: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  watch: {
    lhsValues: {
      immediate: true,
      handler (newVal, oldVal) {
        if (!R.equals(newVal, oldVal)) {
          this.resetLhsData(newVal)
        }
      }
    },
    rhsValues: {
      immediate: true,
      handler (newVal, oldVal) {
        if (!R.equals(newVal, oldVal)) {
          this.resetRhsData(newVal)
        }
      }
    },
    mappingPresets (newVal, oldVal) {
      this.mapFields()
    }
  },
  data () {
    return {
      // the below fields will always be the same length as the lhsData
      lhsData: [], // all available fields == lhsData
      rhsData: [], // mapped fields, not all available values
      defaultValueData: [],
      rhsFields: [] // list of available rhs fields
    }
  },
  methods: {
    resetLhsData (lhsData) {
      this.$logger.trace('!!! RESET LHS DATA !!!')
      this.lhsData = lhsData
      this.resetRhsData(this.rhsFields || [])
    },
    resetRhsData (rhsFields) {
      this.rhsFields = rhsFields

      // reset RHS Data and Default Values...
      const fieldLen = this.lhsData.length
      this.rhsData = Array(fieldLen)
      this.defaultValueData = Array(fieldLen).fill('')

      this.mapFields()
    },
    mapFields () {
      this.$logger.trace('!!! MAPPING FIELDS !!!')
      const combinedMapping = this.value.concat(this.mappingPresets)

      for (let i = 0; i < this.lhsData.length; i++) {
        let lhsField = this.lhsData[i]
        let match = R.where({
          lhs: R.equals(lhsField),
          rhs: (rhsVal) => R.includes(rhsVal, this.rhsFields)
        })

        let target = R.find(match)(combinedMapping)
        if (target) {
          this.$set(this.rhsData, i, target.rhs)
          this.$set(this.defaultValueData, i, target.default_value)
        }
      }
      this.notifyMappingChanged()
    },
    buildFieldMapping (lhsField, rhsField, defaultValueField) {
      return { lhs: lhsField, rhs: rhsField, default_value: defaultValueField }
    },
    saveEventMapping () {
      const dataMapping = this.lhsData.map((lhsField, index) => {
        return this.buildFieldMapping(lhsField, this.rhsData[index], this.defaultValueData[index])
      })
      this.$emit('on-mapping-change', dataMapping)
      this.$emit('on-mapping-editor-save', dataMapping)
      this.closeMapper()
    },
    notifyMappingChanged () {
      const dataMapping = this.lhsData.map((lhsField, index) => {
        return this.buildFieldMapping(lhsField, this.rhsData[index], this.defaultValueData[index])
      })
      this.$emit('on-mapping-change', dataMapping)
    },
    closeMapper () {
      this.$emit('on-mapping-editor-close', true)
    }
  }
}
</script>
